<!-- ProductoStock.svelte -->
<script>
	import {execQuery,execMutation} from '../csql.js'
	export let item = {}
	export let visible=false


	let formdata = {}
	let loading=false
	let update = false
	let itm_updated = 0

	function formdata_default(){
		return { idproducto:item.id, subproducto :'',size:'UNICO',qtty:0,qttysold:0,alertqtty:2,status:1}
	}

	formdata = formdata_default()
	

	let rs=[]
	let where_extra = ''

	$: {
		if(update) where_extra = ' and 1=1 '
		else where_extra = ' and 2=2 '
		getData()
	}

	const getData = async () => {
		loading = true
		let where_extra = '' 
	
		let query = `select * from stock where status=1 and idproducto=${item.id} ${where_extra} order by size `
		//console.log(query)
		const data = await execQuery({query})
		loading= false
		rs = data.data[0] || []
		//eof = ds.length<rpp?true:false
		//productos_ds = [...productos_ds,...ds]
	}

	function editar(itm){
		if(sanitizar(itm)) guardar(itm)
	}

	function borrar(itm){
		itm["status"] = 0
		guardar(itm)
	}

	function insertar(){
		if(sanitizar(formdata)) guardar(formdata)
	}

	function cancelar(){
		formdata = formdata_default()
		update= !update
	}

	function sanitizar(itm){
		itm["subproducto"] = (itm["subproducto"]||"").trim().toUpperCase()
		if(itm["subproducto"]==="") return false
		itm["size"] = (itm["size"].toString()||'UNICO').trim().toUpperCase()
		itm["qtty"] = parseInt(itm["qtty"]||0)
		return true
	}

	async function guardar(item){
		loading = true
		let data = {
			tabname: 'stock', 
			mutation: (item && item.id && item.id>0) ? 'update' : 'insert',
			mutationId: 'id',
			params: item
		}
		const res = await execMutation(data)
		loading = false
		if(res && res.success==="OK"){
			// alert("datos guardados")
			formdata = formdata_default()
			update= !update
		}else{
			alert("ERROR, no se realizo actualizacion!!!")
		}
		itm_updated = 0
	}

	function addStock(){

	}

</script>


<div class="modal">
	<div class=container id="principal" style="min-width:380px;width:100%;height:100vh;background-color:white;position:relative;top:0;left:0;overflow:auto;margin:0 auto;">
		<div class="no-print" style="text-align:center;background-color: #eeeeee;display: flex;justify-content: space-between;min-width:400px;">
			<button style="background-color: transparent;font-size: 1rem; padding:0;margin:0 15px;">❤️ UP+</button>
		  <slot name="salir"></slot>
		</div> 

		{#if loading}
			<div class="spinner"></div>
		{:else}
			<div class="text-right" style="margin:4px;">
				<span class="text-red-600 hover:font-bold hover:bg-red-300 px-2 rounded" on:click={()=>visible=false}>Finalizar  &Cross;</span>
			</div>
			
			<div class="row v-center border" style="margin-bottom:7px;">
				<h4>#{item.id} - {item.nombre}</h4>
			</div>
			<div class="row" style="font-weight:bold;font-size:1.2em">
				<div class="col-sm-4">Modelo/Color</div>
				<div class="col-sm-2">Talle</div>
				<div class="col-sm-2">Qtty</div>
				<div class="col-sm-1">Stock</div>
				<div class="col-sm-3"></div>
			</div>
			{#each rs as itm, index}
				<div class="row v-center">
					<div class="col-sm-4">
						<input class="uppercase w-full" bind:value={itm.subproducto} readonly>
					</div>
					<div class="col-sm-2">
						<input class="uppercase w-full" bind:value={itm.size} readonly>
					</div>
					<div class="col-sm-2 text-center">
						<input class="text-right w-full" type="text" bind:value={itm.qtty} readonly 
							 on:click={()=>{
							 		itm.qtty += parseInt(Math.abs(prompt("Agregar a Stock"))||0)
							 		itm_updated = itm.id
							 	}
							}>
					</div>
					<div class="col-sm-1 text-center">		 
						{itm.qtty-itm.qttysold}
						<input type=hidden bind:value={itm.qttysold} size="2" readonly tabindex="-1">
					</div>
					<div class="col-sm-3 text-center">
						{#if itm.id===itm_updated}
							<button class="small tertiary" on:click={()=>editar(itm)}>&check; Guardar</button>
						{:else}
							<button class="small">&nbsp;</button>
						{/if}
						<button class="small" on:click={()=>borrar(itm)}>&Cross;</button>
					</div>
				</div>
			{/each}
			<div class="row v-center">
				<div class="col-sm-4"><input class="uppercase w-full" bind:value={formdata.subproducto}></div>
				<div class="col-sm-2"><input class="uppercase w-full" bind:value={formdata.size}></div>
				<div class="col-sm-2 text-center">
					<input class="text-right w-full" type="text" bind:value={formdata.qtty}>
				</div>
				<div class="col-sm-1 text-center">
					{formdata.qtty-formdata.qttysold}
					<input type=hidden bind:value={formdata.qttysold} size="2" readonly tabindex="-1">
				</div>
				<div class="col-sm-3 text-center">
					<button class="tertiary small" on:click={()=>insertar()}>&check;</button>
					<button class="small" on:click={()=>cancelar()}>&Cross;</button>
				</div>
			</div>


		{/if}

	</div>
	<code style="color:#999;position:fixed;bottom:10px;right:0;">ProductoStock</code>
</div>


<style>
	input{
		padding:1px 3px;
	}
	button{
		margin:0px 4px;
		padding:2px 6px;
	}
	.row > div {
		/*border: solid 1px black;*/
	}
</style>